import React from 'react';
import { useTranslation } from 'react-i18next';
import ModalForm from '../common/modal-form';
import Button from '../elements/Button';
import HeadingForm from '../elements/HeadingForm';

const AddressMgr = ({
    isOpen,
    toggleModal,
    handleOpenAdd,
    listAddress,
    handleOpenEdit,
    handleOpenDelete
}) => {
    const { t } = useTranslation()

    return (
        <ModalForm
            isOpen={isOpen}
            onClose={() => toggleModal(false)}
            centered
            contentClass="p-0 address-mgr"
        >
            <HeadingForm className="px-10">
                {t('addressMgr.title')}
            </HeadingForm>
            <hr className="m-0"/>
            <div className="p-4">
                {listAddress?.length ? (
                    <div className="address-mgr__list">
                        {listAddress.map((address, index) => (
                            <div className="address-mgr__item" key={index}>
                                <div className="item-info">
                                    <div className="item-info__main">{`${address.street} ${address.addressNumber}`}</div>
                                    <div className="item-info__sub">{`${address.zipCode} ${address.city}`}</div>
                                    <div className="item-info__sub">{address.floor}</div>
                                </div>
                                <div className="actions text-right mt-2">
                                    <span onClick={() => handleOpenEdit(index)}>{t('addressMgr.btnEdit')}</span>
                                    <span onClick={() => handleOpenDelete(index)}>{t('addressMgr.btnDelete')}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="empty text-center">
                        {t('addressMgr.lbEmptyAddress')}
                    </div>
                )}

                <div className="actions text-right mt-4">
                    <Button onClick={handleOpenAdd}>
                        {t('addressMgr.btnAddAddress')}
                    </Button>
                </div>
            </div>
        </ModalForm>
    );
};

export default AddressMgr;